import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { connect } from 'react-redux';
import { AirportSelectorDropdownEl } from './AirportSelectorDropdow.style';
import { WMPUtils } from '../../utils';
import { useSegmentContext } from '../FlightsManager/Segment/SegmentManager/Context';
import { FieldType, LegTypeProps, SearchProp, SourceOptionsType, TabTypeProp, TabTypePropDefault } from '../../models';
import { WMPSource } from '../WMP';

export const AirportSelectorDropdown = ({
    activeProduct,
    sources,
    focus,
    hasBoxStyle,
    onClickItem,
    onClickItemSilent,
    displayedWord,
    isFixedWidth,
    currentSearch,
    departureOrArrival,
}) => {
    const [sourcesToRender, setSourcesToRender] = useState(sources);
    const segmentID = useSegmentContext().segment.id;
    const currentSegmentIndex = currentSearch.segments.findIndex(
        (segment) => segment.id === segmentID,
    );
    const fromOrTo = departureOrArrival === FieldType.DEPARTURE ? 'from' : 'to';
    const classNames = className({
        'odf-box odf-box-layer odf-popup odf-popup-flex odf-space-outer-top-xs opened': hasBoxStyle,
    });
    const options = {
        activeProduct,
        displayedWord,
        onClickItem,
        onClickItemSilent,
        isFixedWidth,
    };

    useEffect(() => {
        const commonArgs = [currentSearch, fromOrTo, currentSegmentIndex];

        let finalSources = sources;
        if (
            WMPUtils.hasCitiesListForCurrentSegmentAndField(...commonArgs) &&
            WMPUtils.shouldWMPCitiesListShow(displayedWord, ...commonArgs)
        ) {
            finalSources = [WMPSource(...commonArgs)];
        }
        setSourcesToRender(finalSources);
    }, [currentSearch, currentSegmentIndex, displayedWord, fromOrTo, sources]);

    return (
        <>
            {focus && (
                <AirportSelectorDropdownEl className={classNames}>
                    <ul>{sourcesToRender.map((source) => source.render(options))}</ul>
                </AirportSelectorDropdownEl>
            )}
        </>
    );
};

AirportSelectorDropdown.propTypes = {
    ...SourceOptionsType,
    onClickItemSilent: PropTypes.func,
    sources: PropTypes.array.isRequired,
    focus: PropTypes.bool,
    isFixedWidth: PropTypes.bool,
    hasBoxStyle: PropTypes.bool,
    currentSearch: SearchProp.isRequired,
    departureOrArrival: LegTypeProps.isRequired,
    activeProduct: TabTypeProp,
};

AirportSelectorDropdown.defaultProps = {
    activeProduct: TabTypePropDefault,
    focus: false,
    isFixedWidth: false,
    onClickItemSilent: () => {},
    hasBoxStyle: true,
};

const mapStateToProps = (state) => ({
    currentSearch: state.currentSearch,
});

export const ConnectedAirportSelectorDropdown = connect(
    mapStateToProps,
    {},
)(AirportSelectorDropdown);
